const supportedLangs = ["en", "ru", "ar", "pt", "es", "fr", "ko"];

export const getLangFromURL = () => {
  const lang =  window.location.pathname.split("/")[1];
  return supportedLangs.includes(lang) ? lang : "en";
};

export const getBaseUrl = () => {
  return `/${getLangFromURL()}/`;
};